export function NextViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({

    template: [
      '<div class="html-element next-action">',
      '  <span class="next-action-label"></span>',
      '  <div class="next-edit-container"><span class="glyphicon glyphicon-pencil next-edit"></span></div>',
      '</div>'
    ].join(''),


    initialize: function () {
      joint.shapes.html.AbstractElementView.prototype.initialize.apply(this, arguments);
      this.updateLabel();
      const editSection = this.$box.find('.next-edit');
      if (this.isEditable()) {
        editSection.on('click', this.editNext.bind(this));
      } else {
        editSection.addClass('hide');
      }
    },

    updateBox: function () {
      joint.shapes.html.AbstractElementView.prototype.updateBox.apply(this, arguments);
      this.updateLabel();
    },

    updateLabel: function () {
      let label = '';
      switch (this.model.get('type')) {
        case 'html.Next':
          label = services.$translate.instant('parameters/quick_replies/details/go_to_next_step');
          break;
        case 'html.Then':
          label = services.$translate.instant('parameters/quick_replies/details/then');
          break;
        case 'html.Else':
          label = services.$translate.instant('parameters/quick_replies/details/else');
          break;
        case 'html.WhenBH':
          label = services.$translate.instant('parameters/quick_replies/details/when_bh');
          break;
        case 'html.WhenNBH':
          label = services.$translate.instant('parameters/quick_replies/details/when_nbh');
          break;
        case 'html.UserInput':
          label = this.model.get('hasVerbatimMode')
            ? services.$translate.instant('parameters/quick_replies/details/verbatim_user_input')
            : services.$translate.instant('parameters/quick_replies/details/user_input');
          break;
        case 'html.RecurringNotifAccepted':
          label = services.$translate.instant('parameters/quick_replies/details/graph/recurring_notif_accepted');
          break;
        case 'html.Optin':
          label = services.$translate.instant('parameters/quick_replies/details/optin_not_optin/optin');
          break;
        case 'html.NotOptin':
          label = services.$translate.instant('parameters/quick_replies/details/optin_not_optin/not_optin');
          break;
        case 'html.NextWithDelay':
          label = services.$translate.instant('parameters/quick_replies/details/go_to_next_step_after_delay');
          break;
        case 'html.SetCustomFieldSuccess':
          label = services.$translate.instant('parameters/quick_replies/details/set_custom_field_success');
          break;
        case 'html.SetCustomFieldFail':
          label = services.$translate.instant('parameters/quick_replies/details/set_custom_field_fail');
          break;
        case 'html.PromoCodeFound':
          label = services.$translate.instant('parameters/quick_replies/details/promo_code/out_promo_code_found');
          break;
        case 'html.NoPromoCodesAvailable':
          label = services.$translate.instant('parameters/quick_replies/details/promo_code/out_no_promo_codes_available');
          break;
        case 'html.UserAlreadyGotPromoCode':
          label = services.$translate.instant('parameters/quick_replies/details/promo_code/out_user_already_got_promo_code');
          break;
        case 'html.ApiConnectorSuccessExit':
          label = services.$translate.instant('parameters/quick_replies/details/api_connector/success-exit');
          break;
        case 'html.ApiConnectorFailExit':
          label = services.$translate.instant('parameters/quick_replies/details/api_connector/fail-exit');
          break;
        case 'html.OtherUserInputText':
          label = services.$translate.instant('parameters/quick_replies/details/condition_on_user_input/other_user_input_text');
          break;
      };
      this.$box.find('.next-action-label').text(label);
    },

    isEditable: function () {
      // For now, editable iff this "next" element can trigger recording of a verbatim
      // This is the case on a whatsapp satisfaction survey, for "list message" and "message with buttons" boxes
      return context.isSatisfactionSurvey
        && ['whatsapp'].includes(context.site.type_name)
        && ['html.WhatsappListMessageBox', 'html.WhatsappMessageWithButtonsBox'].includes(this.getParent().get('type'));
    },

    editNext: function (evt) {
      services.$mdDialog.show({
        controller: 'editNextController',
        template: require('./editNext.modal.html'),
        locals: {
          next: {
            hasVerbatimMode: this.model.get('hasVerbatimMode'),
          },
          shouldShowVerbatimCheckbox: true,
        }
      }).then(result => {
        this.model.set('hasVerbatimMode', result.hasVerbatimMode);
        callbacks.updateSerializedGraph(this.model.graph);
      });
    },
  });
}
